export default __webpack_public_path__ + "static/media/Namitha.486f8017.jpg";